import * as React from 'react';
import "./vyberservisupage.scss";
import MapBodyContainer from "../../components/MapaServisu/MapBodyContainer";
import {useContext, useEffect, useState} from "react";
import {FilterContext} from "../../context/FilterContext";
import VyberServisuHeader from "./VyberServisuHeader";
import {ApplicationContext} from "../../context/applicationContext";
import {CENTRUM_PRAHY_SOURADNICE} from "../../context/FilterProvider";
import { MapContext } from "../../context/MapContext";

export type ILocation = {
    lat: string;
    lng: string;
}

const VyberServisuPageContent = () => {
    const { updateFilterParams, filterParams} = useContext(FilterContext);
    const [intialLoad, setIntitialLoad] = useState(false);

    useEffect(() => {
        if(intialLoad){
            const scrolling = document.scrollingElement;
            if (scrolling !== null) {
                scrolling.scrollTop = 0;
            }
        }
        if(intialLoad && filterParams.lat && filterParams.lng){
            navigator.geolocation.getCurrentPosition(function (position) {
                    if(CENTRUM_PRAHY_SOURADNICE.lat === filterParams.lat && CENTRUM_PRAHY_SOURADNICE.lng === filterParams.lng){
                        updateFilterParams({lat: position.coords.latitude.toString(), lng: position.coords.longitude.toString()});
                    }
                },
                function(error) {
                    console.error("Errors Code = " + error.code + " - " + error.message);
                }
            );
        }
        else {
            setIntitialLoad(true);
        }
    }, [intialLoad])

    return (
            <div className={"vyber-servisu-page"}>
                <div className={"vyber-servisu-page__wrapper"}>
                    <VyberServisuHeader />
                    <MapBodyContainer />
                </div>
            </div>
    )
}
export default VyberServisuPageContent;